// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9691f270","703":"cc6e685e","787":"2e8ad7e0"}[chunkId] + ".chunk.js";
};